import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getHourSlots } from '../../Constant.js'
import axios from 'axios'
import { withRouter } from 'react-router'
import Select from 'react-select'

class DiwaniyaMasterAdd extends React.Component {
  state = {
    item_name_en: '',
    item_name_ar: '',
    item_desc_en: '',
    item_desc_ar: '',
    item_amount: 0,
    diwaniya_category_id: '',
    cruise_category_id: '',

    start_time: '',
    end_time: '',
    selected_cruises: [],
    selected_chalet: [],

    is_active: true,
    item_img: '',
    video_url: '',

    Edit: false,
    img: '',
    video: '',
    isImageChanged: false,
    isVideoChanged: false,

    isSaving: false,

    chaletList: [],

    cruiseCategoryList: [],
    cruiseList: {},
    diwaniyaCategoryList: [],
    source: 'OWNER',
    store_data: {},
    store_list: [],
  }

  componentDidMount = () => {
    if (this.props.match.params.id) {
      this.setState(
        {
          id: this.props.match.params.id,
        },
        () => {
          this.getDiwaniya()
        }
      )
    }
    this.getCategories()
    this.getCruiseCategories()
    this.getChaletList()
  }

  getChaletList = async () => {
    let chaletList = await axios.get(Constant.getAPI() + '/chalet/list-chalet', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (chaletList.status == 200 && chaletList?.data?.data && chaletList?.data?.data.length > 0) {
      this.setState({
        chaletList: chaletList.data.data.map((itm) => ({
          label: itm.name_en + ' \\ ' + itm.name_ar,
          value: itm.id,
        })),
      })
    }
  }

  getCruiseCategories = async () => {
    let categoryList = await axios.get(Constant.getAPI() + '/cruise/list-cruise-masters', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (
      categoryList.status == 200 &&
      categoryList.data &&
      categoryList.data.data &&
      categoryList.data.data.length > 0
    ) {
      this.setState(
        {
          cruiseCategoryList: categoryList.data.data.filter(
            (item) => item.is_active == true && item.category_type == 'CRUISE'
          ),
        },
        () => {
          this.state.cruiseCategoryList.forEach(async (category) => {
            if (category.category_type == 'CRUISE') {
              let list = await axios.get(
                Constant.getAPI() + '/cruise/cruise-listing/' + category.cruise_cat_en + '/' + category.id,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                  },
                }
              )

              if (list.status == 200 && list.data && list.data.data && list.data.data.length > 0) {
                this.setState({
                  cruiseList: {
                    ...this.state.cruiseList,
                    [category.id]: list.data.data
                      .filter((item) => item.is_active)
                      .map((itm) => ({
                        label: itm.cruise_name_en + ' \\ ' + itm.cruise_name_ar,
                        value: itm.id,
                      })),
                  },
                })
              }
            }
          })
        }
      )
    }
  }

  getCategories = async () => {
    await axios
      .get(Constant.getAPI() + `/cruise/list-diwaniya-categories?activeOnly=true`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            diwaniyaCategoryList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDiwaniya = async () => {
    this.setState({ isloading: true })
    const id = this.props.match.params.id
    await axios
      .get(Constant.getAPI() + `/diwaniya/diwaniya-details/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState(
            {
              ...res.data.data,
            },
            async () => {
              if (this.state?.cruise_diwaniya?.length > 0) {
                let temp_selected_cruise = []
                this.state.cruise_diwaniya.forEach((itm) => {
                  temp_selected_cruise.push({
                    value: itm?.wave_cruise?.id,
                    label: itm?.wave_cruise?.cruise_name_en + ' \\ ' + itm?.wave_cruise?.cruise_name_ar,
                  })
                })

                this.setState({
                  selected_cruises: temp_selected_cruise,
                })
              }
              if (this.state?.chalet_diwaniya?.length > 0) {
                let temp_selected_chalet = []
                this.state.chalet_diwaniya.forEach((itm) => {
                  temp_selected_chalet.push({
                    value: itm?.chalet?.id,
                    label: itm?.chalet?.name_en + ' \\ ' + itm?.chalet?.name_ar,
                  })
                })

                this.setState({
                  selected_chalet: temp_selected_chalet,
                })
              }
              if (this.state.source !== 'OWNER') {
                await this.getStoreList(this.state.source)
                this.setState({
                  store_data: this.state.store_list?.find((ele) => ele.value === this.state.store_id),
                })
              }
            }
          )

          this.setState({ Edit: true })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addDiwaniya = async () => {
    if (this.state.source !== 'OWNER' && !this.state.store_data) {
      Swal.fire('Store Required', '', 'error')
      return
    }

    const data = new FormData()

    if (this.state.item_img && this.state.isImageChanged) data.append('item_img', this.state.item_img)
    if (this.state.video_url && this.state.isVideoChanged) data.append('video_url', this.state.video_url)

    data.append('item_name_en', this.state.item_name_en)
    data.append('item_name_ar', this.state.item_name_ar)
    data.append('item_desc_en', this.state.item_desc_en)
    data.append('item_desc_ar', this.state.item_desc_ar)
    data.append('item_amount', this.state.item_amount)
    data.append('diwaniya_category_id', this.state.diwaniya_category_id)
    data.append('cruise_category_id', this.state.cruise_category_id)
    data.append('shop_min_hour', this.state.shop_min_hour)
    if (this.state.cruise_category_id == 'chalet') {
      data.append('selected_chalet', this.state?.selected_chalet?.map((itm) => itm.value) || [])
    } else {
      data.append('selected_cruises', this.state?.selected_cruises?.map((itm) => itm.value) || [])
      data.append('start_time', this.state.start_time)
      data.append('end_time', this.state.end_time)
    }

    data.append('source', this.state.source)
    if (this.state.store_data) {
      data.append('store_id', this.state.store_data.value)
    }

    data.append('is_active', this.state.is_active)

    this.setState({ isSaving: true })

    if (this.props.match.params.id) {
      data.append('id', this.props.match.params.id)

      await axios
        .put(Constant.getAPI() + `/diwaniya/update-diwaniya`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            Swal.fire({
              title: 'Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/diwaniya`
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    } else {
      axios
        .post(Constant.getAPI() + '/diwaniya/create-diwaniya', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            Swal.fire({
              title: 'Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/diwaniya`
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })

    if (event.target.name == 'cruise_category_id') {
      this.setState({
        selected_cruises: [],
        selected_chalet: [],
        start_time: '',
        end_time: '',
      })
    }

    if (event.target.name === 'source') {
      this.getStoreList(event.target.value)
    }
  }

  handleSelectCruise = (event) => {
    this.setState({ selected_cruises: event })
  }
  handleSelectChalet = (event) => {
    this.setState({ selected_chalet: event })
  }

  handleChangeImage = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
      img: URL.createObjectURL(e.target.files[0]),
      isImageChanged: true,
    })
  }

  handleChangeVideo = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
      video: URL.createObjectURL(e.target.files[0]),
      isVideoChanged: true,
    })
  }

  getStoreList = async (type) => {
    this.setState({ store_list: [], store_data: null })
    await axios
      .get(Constant.getAPI() + `/store/get-store-list/${type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            store_list: res.data.data.map((ele) => ({ label: `${ele.name_en}/${ele.name_ar}`, value: ele.id })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleSelectStore = (event) => {
    this.setState({ store_data: event })
  }

  handleClear = () => {
    this.setState({ store_data: null })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_en"
                    placeholder="Item Name: English"
                    onChange={this.handleChange}
                    value={this.state.item_name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Item Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="item_name_ar"
                    placeholder="Item Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.item_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="item_desc_en"
                    placeholder="Description: English"
                    onChange={this.handleChange}
                    value={this.state.item_desc_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description : Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="item_desc_ar"
                    placeholder="Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.item_desc_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="item_amount"
                    placeholder="Amount"
                    onChange={this.handleChange}
                    value={this.state.item_amount}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Addons Category</label>
                <div className="col-sm-9">
                  <select
                    name="diwaniya_category_id"
                    className="form-control"
                    value={this.state.diwaniya_category_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Category</option>
                    {this.state.diwaniyaCategoryList.map((item) => (
                      <option
                        value={item.id}
                        key={item.id}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Shop Min Hours</label>
                <div className="col-sm-9">
                  <select
                    name="shop_min_hour"
                    className="form-control"
                    value={this.state.shop_min_hour}
                    onChange={this.handleChange}
                  >
                    <option value="">Select time</option>
                    {getHourSlots().map(
                      (itm) => itm.value != '00:00:00' && <option value={itm.value}>{itm.label}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Commision Source</label>
                <div className="col-sm-9">
                  <select
                    name="source"
                    className="form-control"
                    value={this.state.source}
                    onChange={this.handleChange}
                  >
                    <option value="OWNER">OWNER </option>
                    <option value="STORE">STORE</option>
                    <option value="FOOD">FOOD</option>
                  </select>
                </div>
              </div>
            </div>
            {this.state.source !== 'OWNER' && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Select {this.state.source}</label>
                    <div className="col-sm-9">
                      <Select
                        name="store_data"
                        value={this.state.store_data}
                        onChange={this.handleSelectStore}
                        options={this.state.store_list}
                        isMulti={false}
                        isSearchable={true}
                        isClearable
                        onClear={this.handleClear}
                        placeholder="Select Store"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6"></div>
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderTop: '1px solid #ddd', marginBottom: 15 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Cruise/Chalet Category</label>
                <div className="col-sm-9">
                  <select
                    name="cruise_category_id"
                    className="form-control"
                    value={this.state.cruise_category_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Category</option>
                    {this.state.cruiseCategoryList.map((item) => (
                      <option
                        value={item.id}
                        key={item.id}
                      >
                        {item.cruise_cat_en} / {item.cruise_cat_ar}
                      </option>
                    ))}
                    <option
                      value={'chalet'}
                      key={'chalet'}
                    >
                      {'chalet'} / {'chalet'}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            {this.state.cruise_category_id == 'chalet' ? (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Chalet list</label>
                    <div className="col-sm-9">
                      <Select
                        name="chalet_reference_id"
                        value={this.state.selected_chalet}
                        onChange={this.handleSelectChalet}
                        options={this.state.chaletList}
                        isMulti={true}
                        isSearchable={true}
                        placeholder="Select Chalet"
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              this.state.cruise_category_id != '' && (
                <>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Yacht list</label>
                      <div className="col-sm-9">
                        <Select
                          name="reference_id"
                          value={this.state.selected_cruises}
                          onChange={this.handleSelectCruise}
                          options={this.state.cruiseList[this.state.cruise_category_id]}
                          isMulti={true}
                          isSearchable={true}
                          placeholder="Select Yacht"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Opening time</label>
                      <div className="col-sm-9">
                        <select
                          name="start_time"
                          className="form-control"
                          value={this.state.start_time}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Opening time</option>
                          {getHourSlots().map((itm) => (
                            <option
                              value={itm.value}
                              key={itm.value}
                            >
                              {itm.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Closing time</label>
                      <div className="col-sm-9">
                        <select
                          name="end_time"
                          className="form-control"
                          value={this.state.end_time}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Closing time</option>
                          {getHourSlots().map((itm) => (
                            <option
                              value={itm.value}
                              key={itm.value}
                            >
                              {itm.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </>
              )
            )}

            <div
              className="col-md-12"
              style={{ borderTop: '1px solid #ddd', marginBottom: 15 }}
            ></div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="item_img"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                    <div style={{ color: 'red' }}>Image height width must be 1160 * 600</div>
                    <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                  </div>
                  {this.state.img ? (
                    <img
                      height="200px"
                      src={this.state.img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : this.state.Edit && this.state.item_img ? (
                    <img
                      height="200px"
                      src={Constant.getImage() + this.state.item_img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Video</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="video"
                        name="video_url"
                        accept="video/*"
                        className="w-100"
                        onChange={this.handleChangeVideo}
                      />
                    </div>
                  </div>
                  {this.state.video ? (
                    <video
                      width="200px"
                      height="150px"
                      controls
                      src={this.state.video}
                    />
                  ) : this.state.Edit && this.state.video_url ? (
                    <video
                      width="200px"
                      height="150px"
                      controls
                      src={Constant.getImage() + this.state.video_url}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">InActive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                {this.state.isSaving ? (
                  <button
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.addDiwaniya}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(DiwaniyaMasterAdd)
